// extracted by mini-css-extract-plugin
module.exports = {"arrow-left":"Arrow_arrow-left__SDkbO","arrow-right":"Arrow_arrow-right__9IL7P"};